export const VIDFLEET_INFORMATION_OPEN_MODAL = "VIDFLEET_INFORMATION_OPEN_MODAL";
export const VIDFLEET_INFORMATION_CLOSE_MODAL = "VIDFLEET_INFORMATION_CLOSE_MODAL";
export const VIDFLEET_INFORMATION_REQUEST = "VIDFLEET_INFORMATION_REQUEST";
export const VIDFLEET_INFORMATION_RESULT = "VIDFLEET_INFORMATION_RESULT";

export const VIDFLEET_INFORMATION_SETTINGS_REQUEST = "VIDFLEET_INFORMATION_SETTINGS_REQUEST";
export const VIDFLEET_INFORMATION_SETTINGS_RESULT = "VIDFLEET_INFORMATION_SETTINGS_RESULT";

export const VIDFLEET_GET_CLIP_TIME_RANGE_REQUEST = "VIDFLEET_GET_CLIP_TIME_RANGE_REQUEST";
export const VIDFLEET_GET_CLIP_TIME_RANGE_RESULT = "VIDFLEET_GET_CLIP_TIME_RANGE_RESULT";


